import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-43140a92"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "px-3" }
const _hoisted_2 = { class: "wrap" }

import { useRoute, useRouter } from 'vue-router'
import { ref } from 'vue'

import SelectAccount from './SelectAccount.vue'
import { useApprovalsStore } from '@/popup/store/ApprovalsStore'
import { useGlobals } from '@/popup/compositions/useGlobals'
import { redirectAfterApproval } from '@/popup/utils/redirectAfterApproval'
import { useAppStore } from '@/popup/store/AppStore'
import { InternalAPI, InternalMethods } from '@/shared/apis/messages'
import Sanitize from '@/popup/components/shared/Sanitize.vue'
import IconButton from '@/popup/components/shared/IconButton.vue'
import Notification from '@/popup/components/shared/Notification.vue'
import { getErrorMessage } from '@/shared/validators'
import { removeSchemaFromUrl, truncateMiddle } from '@/shared/utils'
import {
  Approval,
  ApprovalApi,
  APPROVAL_ACTION,
  ApprovalOutput,
} from '@/shared/apis/approvals'


export default /*#__PURE__*/_defineComponent({
  __name: 'RelayerAccounts',
  setup(__props) {

const route = useRoute()
const router = useRouter()
const appStore = useAppStore()
const approvalsStore = useApprovalsStore()
const approvalId = <string>route.params['id']
const approval = approvalsStore.getApproval(approvalId) as Approval<
  'relayer',
  ApprovalApi['relayer']['input']
>
const incomingRelayService = ref(approval.requestData)
const selected = ref<string[]>([])
const isSubmitting = ref(false)
const relayerError = ref<string>()

const handleSelect = () => {
  relayerError.value = undefined
}

const handleAccept = async (
  selectedProfileAddresses: string[],
  action: APPROVAL_ACTION
) => {
  const globals = useGlobals()
  isSubmitting.value = true

  let data: ApprovalOutput<'relayer'> | undefined
  if (action === 'CONFIRMED') {
    const relayServiceData = incomingRelayService.value.relayService
    const newRelayService: InternalAPI[InternalMethods.ADD_RELAY_SERVICE]['payload'] =
      {
        name: relayServiceData.name,
        chainIDs: relayServiceData.chainIds,
        apiURL: relayServiceData.apiUrl,
      }
    const addRelayServiceResponse = await globals.sendMessage({
      method: InternalMethods.ADD_RELAY_SERVICE,
      payload: newRelayService,
    })

    isSubmitting.value = false
    if (!addRelayServiceResponse.success) {
      relayerError.value = getErrorMessage(addRelayServiceResponse.error)
      return
    }

    data = {
      profileAddresses: selectedProfileAddresses,
    }
  }

  const directive = await globals.sendMessage({
    method: InternalMethods.HANDLE_APPROVAL,
    payload: {
      action,
      requestId: approval.id,
      data,
    },
  })
  approvalsStore.processDirective(directive)
  isSubmitting.value = false

  redirectAfterApproval(
    router,
    approvalsStore.nonStashedApprovals.length,
    appStore.lastPopupState?.path
  )
}

return (_ctx: any,_cache: any) => {
  return (_unref(approval))
    ? (_openBlock(), _createBlock(SelectAccount, {
        key: 0,
        "is-submitting": isSubmitting.value,
        title: _ctx.$t('relayer_account.header'),
        "handle-accept": handleAccept,
        "handle-select": handleSelect,
        "default-selected-keys": selected.value,
        "only-one-selection": false,
        "has-error": !!relayerError.value
      }, _createSlots({
        subtitle: _withCtx(() => [
          _createVNode(Sanitize, {
            html: _unref(truncateMiddle)(_unref(removeSchemaFromUrl)(_unref(approval)?.origin), 25)
          }, null, 8 /* PROPS */, ["html"])
        ]),
        title: _withCtx(() => [
          _createElementVNode("span", null, _toDisplayString(_ctx.$t('relayer_account.request_profile')), 1 /* TEXT */)
        ]),
        actions: _withCtx(() => [
          _createVNode(IconButton, {
            class: "button-cancel",
            tooltip: _ctx.$t('sign.cancel'),
            onOnClick: _cache[0] || (_cache[0] = ($event: any) => (handleAccept([], 'REJECTED')))
          }, null, 8 /* PROPS */, ["tooltip"])
        ]),
        "select-account-title": _withCtx(() => [
          _createTextVNode(_toDisplayString(_ctx.$t('select_account.select_profiles')), 1 /* TEXT */)
        ]),
        _: 2 /* DYNAMIC */
      }, [
        (relayerError.value)
          ? {
              name: "relayer-error",
              fn: _withCtx(() => [
                _createElementVNode("div", _hoisted_1, [
                  _createVNode(Notification, {
                    class: "mt-3",
                    type: "error"
                  }, {
                    default: _withCtx(() => [
                      _createElementVNode("span", _hoisted_2, _toDisplayString(relayerError.value), 1 /* TEXT */)
                    ]),
                    _: 1 /* STABLE */
                  })
                ])
              ]),
              key: "0"
            }
          : undefined
      ]), 1032 /* PROPS, DYNAMIC_SLOTS */, ["is-submitting", "title", "default-selected-keys", "has-error"]))
    : _createCommentVNode("v-if", true)
}
}

})